module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-email",
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : _vm._e(), (_vm.error && !_vm.loading) ? _c('div', {
    staticClass: "failed"
  }, [_c('div', {
    staticClass: "expired"
  }, [_vm._v(_vm._s(_vm.$t('pos.login.token.expired')))]), _c('div', {
    staticClass: "secondary"
  }, [_vm._v(_vm._s(_vm.$t('pos.login.token.call'))), _c('br'), _c('b-badge', {
    staticClass: "phone",
    attrs: {
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.login.token.phone')))])], 1), _c('b-btn', {
    staticClass: "use-email",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.login.token.use-email')))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-849c9a0a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/login/token/Token.vue
// module id = 2076
// module chunks = 1